import { useState, useCallback, useEffect, useRef } from 'react';
import useWebSocket from 'react-use-websocket';
import { throttle } from 'lodash-es';

import config from '../config';

export function useChangeDetection(channel) {
  const [target, setTarget] = useState();
  const [changedResource, setChangedResource] = useState();
  const [isSocketReady, setSocketReady] = useState();
  const throttledUpdatesCache = useRef({});

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(
    `${config.apiUrl}/${channel}`.replace('http', 'ws'),
    { shouldReconnect: () => true },
  );

  // https://github.com/HenningM/express-ws/issues/113#issue-418382893
  useEffect(() => {
    if (lastJsonMessage?.id) {
      const resourceId = lastJsonMessage.id;

      if (!throttledUpdatesCache.current[resourceId]) {
        throttledUpdatesCache.current[resourceId] = throttle(
          (resource) => setChangedResource(resource),
          5000,
          { leading: true, trailing: true },
        );
      }

      throttledUpdatesCache.current[resourceId](lastJsonMessage);
    } else if (target && isSocketReady) {
      sendJsonMessage(target);
    } else if (!isSocketReady && lastJsonMessage?.ready) {
      setSocketReady(true);
    }
  }, [target, isSocketReady, lastJsonMessage, sendJsonMessage]);

  return {
    detectChangesFor: useCallback(setTarget, [setTarget]),
    changedResource,
  };
}
